import { ApiResponse } from 'Public_old/src/app/Classes/visibaHttp.class';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SpaContext } from '../../../../Classes/spacontext';
import { VisibaApiHttp } from '../../../../Classes/visibaHttp.class';
import { PhysicalLocationApiModel } from '../Models/PhysicalLocationApiModel';

@Injectable()
export class PhysicalLocationService {
	private baseUri;

	constructor(
		private http: VisibaApiHttp,
		public spaContext: SpaContext,
	) {
		// Empty
		this.baseUri = `/api/Client/v2/units/${this.spaContext.unitConfig.Unit.UnitId}`;
	}

	public getPhysicalReception(): Observable<ApiResponse<PhysicalLocationApiModel[]>> {
		let params = new HttpParams();
		params = params.append('languageCode', this.spaContext.languageCode);

		return this.http.getTyped<PhysicalLocationApiModel[]>(`${this.baseUri}/PhysicalLocations`, true, { params });
	}
}
